"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blueAccents = void 0;
exports.blueAccents = {
    accentColor: "#4090bb",
    accentColorHover: "#55aecf",
    accentColorActive: "#3b7a9c",
};
//# sourceMappingURL=blueAccents.js.map